import type { StepContentConfig } from '../../utils';

export const paiementStepContent: StepContentConfig = {
  mainTitle: {
    site: 'Paiement sécurisé',
  },
  redirectionText: {
    site: 'Redirection vers la page de paiement sécurisé...',
  },
  paymentSecureTitle: {
    site: 'Paiement 100% sécurisé',
  },
  paymentSecureDescription: {
    site: 'Les données bancaires sont cryptées et sécurisées',
  },
  assuranceNote: {
    site: "Votre couverture débutera dés le paiement effectué. Nous vous remercions de nous transmettre les documents demandés sous 60 jours.",
    conseiller: "La couverture débutera dés le paiement effectué. Merci de transmettre les documents demandés sous 60 jours.",
  },
  buttonText: {
    site: 'Procéder au paiement',
  },
};
